module.exports = __webpack_public_path__ + "img/ammiraglio 6.e339404b.jpeg";